export const branchNumber = '9999'
export const accountNumber = '99999-9'
export const operatorCode = '999999999'
export const creditCard = '9999 9999 9999 9999'
export const cpf = '999.999.999-99'

export const maskers = {
  branchNumber,
  accountNumber,
  operatorCode,
  creditCard,
  cpf,
}
